import { useStore } from 'zustand';
import { useShallow } from 'zustand/react/shallow';
import { sessionStore } from '../domain/session/sessionStore';
import { selectIsAuthenticated } from '../domain/session/selectors';
import type { SessionContextValue } from '../domain/session/types';

export const useSessionContext = (): SessionContextValue =>
	useStore(
		sessionStore,
		useShallow((state) => ({
			isAuthenticated: selectIsAuthenticated(state),
			isSuperUser: state.isSuperUser,
			isStaff: state.isStaff,
			accessToken: state.accessToken,
		})),
	);
